import axios from "axios";
import getToken from "../../../config/getToken";
import { env } from "../../../env";

axios.interceptors.response.use(
  (response) => {
    if (response.data.responseCode === 1016 || response.status === 403) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/";
    } else {
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Petición para consultar el último aviso de los empleados de un usuario filtrando por NRP
 * @param {*} data filtro
 * @returns avisos
 */
export async function GetEmployeesInfo(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: "avisos/filter",
    data: { ...data, isHome: true },
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Descargar reporte de empleados
 * @param {*} data payload
 * @returns
 */
export async function GetEmployeesReport(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: "avisos/report",
    data: {
      ...data,
      isHome: true,
      isExcel: true,
    },
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Obtener gráficas e indicadores
 * @param {*} data payload
 * @returns
 */
export async function GetChartsAndIndicators(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: "homeCards",
    data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}
